<template>
    <td :class="[column.align, column.imageSrc ? 'tiny-image' : '' , ...column.cellClassList]" :width="column.width" @click="handleCellClick">
        <template v-if="column.renderFunction && typeof column.renderFunction === 'function'">
            <span v-html="column.renderFunction(item)"></span>
        </template>
        <template v-else>
            <span>{{ cellValue }}</span>
        </template>
    </td>
</template>

<script>
    export default {
        name: 'ProductTableCell',
        props: {
            item: {
                type: Object,
                required: true,
            },
            column: {
                type: Object,
                required: true,
            },
        },
        computed: {
            cellValue() {
                return this.item[this.column.key];
            }
        },
        methods: {
            handleCellClick() {
                this.$emit('handleCellClick');
            }
        }
    }
</script>

<style lang="scss" scoped>
td {
    padding: 0.66em 0;
    border-bottom: 1px dotted #dfdce3;

    &:first-child {
        padding-left: 0.5em;
    }
}
</style>